<template>
  <div class="sign_view">
    <div class="query_wapper">
      <div class="query_item">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          style="width:150px"
          v-model="query.year"
          @change="selectYear"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.matchId"
          @change="selectMatch"
          style="width:200px;"
          placeholder="请选择赛事"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.id"
          placeholder="请选择学校"
          style="width:200px;"
          @change="getSignDetail"
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :value="item.id"
            :label="item.schoolName"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" v-if="userInfo.project !== 9" style="flex:1;">
        <el-button type="warning" style="width:90px;margin-right:8px;" @click="print">打印</el-button>
        <!-- <el-button type="primary" style="width:90px" v-if="!isOtherBall" @click="exportPdf">导出</el-button> -->
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="primary" @click="moveBack">返回</el-button>
      </div>
    </div>
    <p
      v-if="details.matchName && switchType === 1"
      style="font-size:24px;color#444;text-align:center;margin:20px 0;"
    >{{details.matchName}}报名表</p>
    <div v-if="switchType === 1" class="table_box">
      <table border="1" bordercolor="#ddd" cellspacing="0" cellpadding="0">
        <thead>
          <th
            v-for="(item,index) in columns"
            :key="index"
            :style="{width:item.width + 'px'}"
          >{{item.title}}</th>
        </thead>
        <tbody>
          <tr v-for="(item,index) in tableData" :key=" index">
            <td>{{index + 1}}</td>
            <template v-for="(temp,num) in columns.slice(1)">
              <td :key="num + '_' + index">{{getKey(temp.key,index)}}</td>
            </template>
          </tr>
        </tbody>
      </table>
      <template v-if="details.matchName">
        <div
          class="foots"
          v-if="details.state === 0"
          :class="getTableList % 3 === 0?'page_break':''"
          style="height:100px;color:#444;padding:20px;"
        >
          <section
            style="font-size:24px;display:flex;height:100%;flex-direction:column;align-items:center;justify-content:center"
          >
            <p>报名未提交</p>
          </section>
        </div>
        <div
          class="foots"
          v-else
          :class="getTableList % 3 === 0?'page_break':''"
          style="width:100%;height:100px;color:#444;padding:10px 20px;"
        >
          <p style="font-size:14px;">体育部意见：</p>
          <p
            style="font-size:24px;text-align:center;margin-top:10px;"
          >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
        </div>
      </template>
      <template v-else>
        <div class="table_list">
          <div style="height:100px;color:#444;padding:20px;">
            <section
              style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
            >
              <p>暂无数据</p>
            </section>
          </div>
        </div>
      </template>
    </div>
    <swimmingAthletesPhoto v-else :details="athleteData"></swimmingAthletesPhoto>
      <div id="swimmingPrint" style="position:absolute;left:-50000px;top:-50000px">
        <swimmingPrint ref="swimmingPrints" :info="query" :matchList="matchList" :name="getSchoolName"></swimmingPrint>
      </div>
  </div>
</template>
<script>
import swimmingPrint from "./swimming-print";
import { getSession } from "@/utils/storage";
import { signDetail, signList } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import swimmingAthletesPhoto from "./swimming-athletes-photo";
import { getMatchList } from "@/api/sports-management";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { message, selectiveYear } from "@/common/js/mixins";
export default {
  // 报名表查看
  components: {
    swimmingAthletesPhoto,swimmingPrint
  },
  mixins: [message, selectiveYear],
  props: {
    info: {
      type: Object
    },
    isListPrint: {
      type: Boolean
    }
  },
  data() {
    return {
      athleteData: {},
      isShowBottom: true,
      loading: null,
      isShowBorder: true,
      isRender: false,
      matchList: [],
      switchType: 1,
      matchName: "",
      schoolList: [],
      details: {},
      tableData: {},
      userInfo: JSON.parse(getSession("userInfo")) || "",
      query: {
        year: "",
        id: "",
        matchId: ""
      },
      columns: [
        {
          title: "序号",
          width: 60
        },
        {
          title: "单位",
          width: 100,
          key: "schoolName"
        },
        {
          title: "身份",
          width: 100,
          key: "identity"
        },
        {
          title: "兼任",
          width: 100,
          key: "partTime"
        },
        {
          title: "性别",
          width: 60,
          key: "gender"
        },
        {
          title: "组别",
          width: 60,
          key: "group"
        },
        {
          title: "姓名",
          width: 100,
          key: "name"
        },
        {
          title: "姓名全拼",
          width: 160,
          key: "pinyin"
        },
        {
          title: "身份证号",
          width: 160,
          key: "idCard"
        },
        {
          title: "出生日期",
          width: 100,
          key: "birthday"
        },
        {
          title: "注册号码",
          width: 150,
          key: "registerNumber"
        },
        {
          title: "比赛号",
          width: 100,
          key: "matchNumber"
        },
        {
          title: "分计单位",
          width: 100,
          key: "subUnit"
        },
        {
          title: "教练",
          width: 80,
          key: "coachName"
        },
        {
          title: "备注",
          width: 80,
          key: "remarks"
        },
        {
          title: "距离",
          width: 80,
          key: "distance"
        },
        {
          title: "泳式",
          width: 100,
          key: "swimmingStyle"
        },
        {
          title: "报名成绩",
          width: 80,
          key: "score"
        },
        {
          title: "测验",
          width: 80,
          key: "test"
        },
        {
          title: "特殊标记",
          width: 80,
          key: "mark"
        }
      ]
    };
  },
  computed: {
    // 网球、羽毛球、乒乓球公用
    isOtherBall() {
      return (
        this.userInfo.project === 1 ||
        this.userInfo.project === 5 ||
        this.userInfo.project === 6
      );
    },
    // 获取学校名称
    getSchoolName() {
      let str = "";
      this.schoolList.filter(item => {
        if (item.id === this.query.id) str = item.schoolName;
      });
      return str;
    },
    // 获取赛事名称
    getMatchName() {
      let str = "";
      this.matchList.filter(item => {
        if (item.id === this.query.matchId) {
          str = item.name;
          this.matchName = item.name;
        }
      });
      return str;
    },
    // 表格显示数量
    getTableList() {
      if (this.userInfo.project === 7) {
        return;
      }
      /**
       * 每个表格显示5项数据，如果数据小于5条，则使用空对象填充
       */
      let num = 0;

      if (
        this.details.swimAthleteList &&
        this.details.swimAthleteList.length < 5
      ) {
        let length = 5 - this.details.swimAthleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.swimAthleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.swimAthleteList &&
        this.details.swimAthleteList.length >= 5
      ) {
        let length = this.details.swimAthleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (
          this.details.swimAthleteList.slice((num - 1) * 5, num * 5).length < 5
        ) {
          let length =
            5 -
            this.details.swimAthleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.swimAthleteList.push({});
          }
        }
      }
      return num;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key && item.key !== "identity") {
            keys = this.tableData[index][item.key];
          } else if (item.key === key && item.key === "identity") {
            switch (this.tableData[index][item.key]) {
              case 1: {
                keys = "运动员";
                break;
              }
              case 2: {
                keys = "教练";
                break;
              }
              case 3: {
                keys = "领队";
                break;
              }
              case 4: {
                keys = "工作人员";
                break;
              }
              case 5: {
                keys = "医生";
                break;
              }
              default: {
                keys = "代表队";
                break;
              }
            }
          }
        });

        return keys;
      };
    }
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          this.switchType = 1;
          Object.assign(this.query, {
            year: value.year,
            matchId: value.matchId,
            id: value.id
          });
          this.getMatch();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 打印
    print() {
      if (this.schoolList.length === 0) {
        return this.openWarn("当前赛事暂无数据打印");
      }
        let interval = setInterval(() => {
          if (this.$refs.swimmingPrints.isRender) {
            clearInterval(interval);
            this.$refs.swimmingPrints.print();
          }
        }, 300);
      // this.$parent.makePrint(this.query.id);
    },
    // 返回上级
    moveBack() {
      Object.assign(this.query, this.$options.data().query);
      this.$emit("backs");
    },
    // 切换按钮组
    selectType(switchType) {
      if (switchType === 2) {
        let arr = [];
        this.details.swimAthleteList.filter(item => {
          if (item.identity === 1) {
            arr.push(item);
          }
        });
        this.athleteData = JSON.parse(JSON.stringify(this.details));
        this.$set(this.athleteData, "swimAthleteList", [...arr]);
      }
      this.switchType = switchType;
    },
    // 选择年份
    selectYear() {
      this.query.matchId = "";
      this.query.id = "";
      this.matchList = [];
      this.schoolList = [];
      this.details = {};
      this.athleteData = {};
      this.tableData = {};
      this.getMatch();
    },
    // 获取赛事
    getMatch() {
      getMatchList({
        project: this.userInfo.project,
        year: this.query.year,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = [];
          if (res.list.length > 0) {
            this.matchList = res.list;
          }
          this.getList();
        })
        .catch(err => {});
    },
    // 选择赛事
    selectMatch(value) {
      this.query.id = "";
      this.schoolList = [];
      this.details = {};
      this.athleteData = {};
      this.tableData = {};
      this.matchList.filter(item => {
        if (item.id === value) {
          this.matchName = item.name;
        }
      });
      this.getList();
    },
    // 获取详情数据
    getSignDetail(id = this.query.id) {
      signDetail({ id })
        .then(res => {
          this.details = res;
          this.selectType(this.switchType);
          this.tableData = JSON.parse(JSON.stringify(res.swimAthleteList));
          this.isRender = true;
        })
        .catch(err => {});
    },
    // 列表数据
    getList() {
      signList({
        ...this.query,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.schoolList = res.list;
          if (this.query.id) this.getSignDetail(this.query.id);
          else {
            if (res.list.length > 0 && this.query.matchId) {
              this.query.id = res.list[0].id;
              this.getSignDetail(this.query.id);
            }
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getYearLists(this.query);
  }
};
</script>
<style lang="less" scoped>
.sign_view {
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
  .table_box {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    border: 1px solid #ddd;
    border-bottom: none;
  }
  table {
    width: 100%;
    table-layout: fixed;
    thead {
      th {
        color: #444;
        font-size: 16px;
        border-right: 1px solid #ddd;
        padding: 14px 0;
        border-bottom: 1px solid #ddd;
        &:last-of-type {
          border-right: none;
        }
      }
    }
    tbody {
      tr {
        td {
          text-align: center;
          font-size: 14px;
          color: #444;
          padding: 10px 0;
          border-right: 1px solid #ddd;
          word-break: break-all;
          vertical-align: middle;
          border-bottom: 1px solid #ddd;
          &:last-of-type {
            border-right: none;
          }
        }
      }
    }
  }
}
</style>